import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { getBankApi } from "../../Api/Bank";
import { getAllBankApi } from "../../Api/Bank";
import { FaPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import SideModal from "../general/Sidemodal";
import { BankDetailsForm } from "./BankDetailsForm";

interface Bank {
  id: string;
  name: string;
  branch: string;
  ifscCode: string;
  accountNumber: string;
  isEzpay: boolean;
}

interface BankDetailsProps {
  url: string;
}

export const BankDetails = ({ url }: BankDetailsProps) => {
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [banks, setBanks] = useState<Bank[]>([]);
  const ITEMS_PER_PAGE = 10;
  const handleSort = (field: string) => setSortBy(field);
  const [showModal, setShowModal] = useState(false);
  const [editBankId, setEditBankId] = useState<string | null>(null);

  const handleEditClick = (id: string) => {
    setEditBankId(id);
    setShowModal(true);
  };

  const handleAddClick = () => {
    setEditBankId(null);
    setShowModal(true);
  };


  const handleApiCallClick = async () => {
    try {
      const bankData = await getAllBankApi(url);
      setBanks(bankData);
    } catch (error) {
      toast.error("Failed to fetch bank data. Some problem occurred. Please try again.");

    }
  };

  useEffect(() => {
    handleApiCallClick();
  }, [url]);

  const sortedBanks = banks.slice().sort((a, b) => {
    if (sortBy) {
      const aValue = a[sortBy as keyof Bank];
      const bValue = b[sortBy as keyof Bank];
      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue);
      }
      if (typeof aValue === "boolean" && typeof bValue === "boolean") {
        return aValue === bValue ? 0 : aValue ? 1 : -1;
      }
    }
    return 0;
  });

  const filteredBanks = sortedBanks.filter((item) =>
    Object.values(item).some(
      (value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(search.toLowerCase());
        }
        if (typeof value === "boolean") {
          const searchLower = search.toLowerCase();
          return (value ? "yes" : "no").includes(searchLower);
        }
        return false;
      }
    )
  );

  const indexOfLastBank = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstBank = indexOfLastBank - ITEMS_PER_PAGE;
  const currentBanks = filteredBanks.slice(indexOfFirstBank, indexOfLastBank);
  const totalPages = Math.ceil(filteredBanks.length / ITEMS_PER_PAGE);

  return (
    <div className={` h-full px-2 md:px-4 bg-[#ffff]`}>

      <div className='flex flex-row items-center  '>
        <h2 className="text-3xl font-bold text-blue-600 mb-4 mt-4">
          Bank Details
        </h2>

        <button
          type="button"
          className=" w-fit px-3 py-2 mx-3 mt-6 mb-4  tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
          onClick={handleAddClick}
        >
          <FaPlus className="w-3 h-3" />
        </button>
      </div>
      <input
        type="text"
        placeholder="Search Bank"
        className="w-full mb-4 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500 border-gray-300"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg mt-5">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                Edit{" "}
              </th>
              <th
                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                onClick={() => handleSort("name")}
              >
                Bank {sortBy === "name" && "↑"}
              </th>
              <th
                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                onClick={() => handleSort("branch")}
              >
                Branch {sortBy === "branch" && "↑"}
              </th>
              <th
                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                onClick={() => handleSort("ifscCode")}
              >
                IFSC Code {sortBy === "ifscCode" && "↑"}
              </th>
              <th
                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                onClick={() => handleSort("accountNumber")}
              >
                Account Number {sortBy === "accountNumber" && "↑"}
              </th>
              <th
                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500"
                onClick={() => handleSort("isEzpay")}
              >
                EzPay {sortBy === "isEzpay" && "↑"}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
            {currentBanks.map((bank) => (
              <tr key={bank.id} className="hover:bg-gray-50">
                <td className="px-4 py-4 text-sm whitespace-nowrap">
                  <div className="flex items-center gap-x-6">
                    <button
                      onClick={() => handleEditClick(bank.id)}
                      className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        className="w-5 h-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
                <td className="px-4 py-4 text-sm font-medium text-gray-500">
                  {bank.name}
                </td>
                <td className="px-4 py-4 text-sm text-gray-500">
                  {bank.branch}
                </td>
                <td className="px-4 py-4 text-sm text-gray-500">
                  {bank.ifscCode}
                </td>
                <td className="px-4 py-4 text-sm text-gray-500">
                  {bank.accountNumber}
                </td>
                <td className="px-4 py-4 text-sm text-gray-500">
                  {bank.isEzpay ? "Yes" : "No"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>



      <div className="flex items-center justify-between mt-6">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-5 h-5 rtl:-scale-x-100"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            />
          </svg>
          <span>Previous</span>
        </button>

        <div className="items-center hidden lg:flex gap-x-3">
          {Array.from({ length: Math.min(10, totalPages) }, (_, index) => {
            const startPage = Math.max(1, currentPage - 5);
            const page = startPage + index;

            if (page > totalPages) return null;

            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-2 py-1 text-sm ${currentPage === page
                  ? "text-blue-500 bg-blue-100"
                  : "text-gray-500 hover:bg-gray-100"
                  } rounded-md`}
              >
                {page}
              </button>
            );
          })}
        </div>

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
        >
          <span>Next</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-5 h-5 rtl:-scale-x-100"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
            />
          </svg>
        </button>
      </div>
      <SideModal isOpen={showModal} onClose={() => setShowModal(false)}>
        <BankDetailsForm
          editBankId={editBankId}
          onClose={() => setShowModal(false)}
          url={url} onSaved={handleApiCallClick}/>.
          
      </SideModal>
    </div>
  );
};
